import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6d12f481"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-message-template" }
const _hoisted_2 = { class: "cm-message-header" }
const _hoisted_3 = { class: "cm-message-body" }

import { PropType } from 'vue'
import { i18n } from '@/i18n'
import { Content } from '@/views/_components/message-template/genuine-software/genuine-software.service'
import { router } from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'genuine-software',
  props: {
  content: {
    type: Object as PropType<Content>,
    default: () => ({} as any)
  },
  notificationKey: {
    type: String,
  }
},
  emits: ['closeDetails'],
  setup(__props, { emit: __emit }) {

const emits = __emit



const t = i18n.global.t.bind(i18n.global)

function handleLink () {
  emits('closeDetails')
  router.push('/dashboard/genuine-software')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('messageTemplate.genuineSoftware.header')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_unref(t)('messageTemplate.genuineSoftware.prefix')) + " ", 1),
      _createElementVNode("strong", null, _toDisplayString(__props.content.num), 1),
      _createTextVNode(" " + _toDisplayString(_unref(t)('messageTemplate.genuineSoftware.unit')) + " ", 1),
      _createElementVNode("strong", null, _toDisplayString(__props.content.soft_name), 1),
      _createTextVNode(_toDisplayString(_unref(t)('messageTemplate.genuineSoftware.installedSuffix')) + " ", 1),
      _createElementVNode("strong", null, _toDisplayString(__props.content.action), 1),
      _createTextVNode(_toDisplayString(_unref(t)('messageTemplate.genuineSoftware.actionSuffix')) + " ", 1),
      _createElementVNode("span", {
        class: "cm-link-light underline",
        onClick: handleLink
      }, _toDisplayString(_unref(t)('messageTemplate.genuineSoftware.linkText')), 1),
      _createTextVNode(_toDisplayString(_unref(t)('messageTemplate.genuineSoftware.suffix')), 1)
    ])
  ]))
}
}

})